// maxium file size
export const MAXIMUM_EXCEL_FILE_SIZE_BYTES = 10000000;

// accepted excel file extensions
export const XLSX_FILE_EXTENSION = "xlsx";
export const XLS_FILE_EXTENSION = "xls";
export const XLSM_FILE_EXTENSION = "xlsm";
